import AlmaLinux from './os/ic-almalinux.png'
import AltLinux from './os/ic-altlinux.png'
import Arch from './os/ic-arch.png'
import Centos from './os/ic-centos.png'
import Cirros from './os/ic-cirros.png'
import Debian from './os/ic-debian.png'
import Dos from './os/ic-dos.png'
import FedoraCoreos from './os/ic-fedora-coreos.png'
import Fedora from './os/ic-fedora.png'
import FedoraAtomic from './os/ic-fedora-atomic.png'
import Freebsd from './os/ic-freebsd.png'
import Gnome from './os/ic-gnome.png'
import Macos from './os/ic-macos.png'
import Mageia from './os/ic-mageia.png'
import Mandrake from './os/ic-mandrake.png'
import Mandriva from './os/ic-mandriva.png'
import Netbsd from './os/ic-netbsd.png'
import Netware from './os/ic-netware.png'
import Openbsd from './os/ic-openbsd.png'
import Opensuse from './os/ic-opensuse.png'
import Rhel from './os/ic-rhel.png'
import Rockylinux from './os/ic-rockylinux.png'
import Solaris from './os/ic-solaris.svg'
import Ubuntu from './os/ic-ubuntu.png'
import Windows from './os/ic-windows.png'
import Undefined from './os/ic-undefined.png'

export const handleOsIcons = (os:string) => {
  switch (os) {
    // case 'ubuntu':
    case 'almalinux' :
      return AlmaLinux
    case 'rockylinux' :
      return Rockylinux
    case 'altlinux' :
      return AltLinux
    case 'arch' :
      return Arch
    case 'centos' :
      return Centos
    case 'cirros' :
      return Cirros
    case 'debian' :
      return Debian
    case 'dos' :
      return Dos
    case 'fedora' :
      return Fedora
    case 'fedora-atomic' :
      return FedoraAtomic
    case 'fedora-coreos' :
      return FedoraCoreos
    case 'freebsd' :
      return Freebsd
    case 'gnome' :
      return Gnome
    case 'macos' :
      return Macos
    case 'mageia' :
      return Mageia
    case 'mandrake' :
      return Mandrake
    case 'mandriva' :
      return Mandriva
    case 'netbsd' :
      return Netbsd
    case 'netware' :
      return Netware
    case 'openbsd' :
      return Openbsd
    case 'opensuse' :
      return Opensuse
    case 'rhel' :
      return Rhel
    // case 'rhl' :
    //   return 
    case 'solaris' :
      return Solaris
    // case 'suse' :
    //   return 
    case 'ubuntu' :
      return Ubuntu
    case 'windows' :
      return Windows
    default:
      return Undefined
  }
}
